<template>
    <!-- types -->
    <app-collapse
      accordion
      :type="'margin'"
    >
      <div class="d-flex align-items-center">
        <b-avatar
          rounded
          size="32"
          variant="light-danger"
          class="mr-75"
        >
          <feather-icon
            icon="MessageSquareIcon"
            size="16"
          />

        </b-avatar>
        <div>
          <h4 class="mb-0 page-title">
            Compare Product
          </h4>
          <b-link @click="detail()" class="title"><feather-icon
            icon="ArrowLeftIcon"
            size="16"
            style="margin-bottom:0.3rem;"
          />{{title}}</b-link>
        </div>
      </div>

    <b-card class="pt-1">
      <b-col cols="12" sm="12" lg="12">
        <b-form-group label-for="product">
          <template slot="label">
            <span>Product <strong class="text-danger">*</strong></span>
          </template>
          <v-select
            v-model="selectedProducts"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            multiple
            @input="onChangeProduct"
            :options="products"
          />
        </b-form-group>
        <b-spinner v-if="loading" class="align-middle mr-1" variant="secondary"></b-spinner>
      </b-col>
      <b-col v-if="selectedProducts ? selectedProducts.length > 0 : false"
        cols="12"
        md="12"
        class="mb-1 d-flex align-items-center justify-content-end mb-md-0"
      >
        <b-button variant="primary" @click="clearSelectedProduct()">Clear All</b-button>
      </b-col>

      <b-col class="pt-3 px-0 px-sm-2" cols="12">
        <b-card class="px-0 px-sm-2 py-2" title="Compare Result">
          <div class="m-2">
            <!-- Table Top -->
            <b-row>
              <!-- Per Page -->
              <b-col
                cols="12"
                md="6"
                class="mb-1 d-flex align-items-center justify-content-start mb-md-0"
              > 
              </b-col>

              <!-- Search -->
              <b-col
                cols="12"
                md="6"
                class="mb-1 d-flex align-items-center justify-content-end mb-md-0"
              >
                <b-button @click="exportToExcel(
                    compare,
                    excelFields,
                    excelFieldsVal,
                    ['Compare Product'],
                    formatJson
                  )" variant="primary"
                  >Export Excel</b-button
                >
              </b-col>
            </b-row>
          </div>
          <b-table
            class="border"
            responsive
            striped
            ref="table"
            :items="compare"
            :fields="compareFields"
          />
          <div class="px-2 mb-2">
            <b-row>
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
              >
              </b-col>
              <!-- Pagination -->
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>
    </b-card>
    <b-modal
      ref="modal-notif"
      centered
      title="Vertically Centered"
      :hide-footer="true"
      :hide-header="true"
      size="md"
    >
      <div class="d-flex flex-column align-items-center">
        <div class="align-self-end"> 
          <b-button
            v-ripple.400="'rgba(40, 199, 111, 0.15)'"
            variant="flat-secondary"
            class="btn-icon"
            size="md"
            @click="$refs['modal-notif'].hide()"
          >
            <feather-icon icon="XIcon" />
          </b-button>
        </div>
        <div class="h2 text-danger mb-2 text-center">
          Produk tidak tersedia untuk diperbandingkan
        </div>
        <b-card-text class="mb-2">
          <p>
            Untuk saat ini data produk yang dipilih tidak ada data pembanding, silahkan pilih produk lain
          </p>
        </b-card-text>
        <b-button
              style="width: 100%;"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="success"
              class="mb-2"
              @click="$refs['modal-notif'].hide()"
            > Close </b-button>
      </div>
    </b-modal>
    </app-collapse>
</template>

<script>
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import CompareTable from '@/views/user/product/CompareTable.vue'
import Ripple from 'vue-ripple-directive'
import {
  BModal,BSpinner,BTable,BFormGroup,BCard, BCardText,BLink,BAvatar,BRow,BCol,BButton
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BSpinner,
    BButton,
    BTable,
    BRow,
    BCol,
    BModal,
    BCard,
    BAvatar,
    BLink,
    AppCollapse,
    AppCollapseItem,
    BCardText,
    BFormGroup,
    CompareTable,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      loading: true,
      selectedProducts: null,
      selectedCategories: null,
      productCategories: [],
      products: [],
      collapseType: 'default',
      title: null,
      code: [],
      compare: [],
      excelFields: [],
      excelFieldsVal: [],
      compareFields: [
        { key: 'param', label: 'Parameter', sortable: false }
      ],
    }
  },
  created() {
    this.$http.get('/product/id/'+this.$route.params.key+'/set/first/published/true').then(response => { 
      this.$store.commit('app/SET_PAGE_TITLE',response.data.data.records.PRODUCT)
      this.title = response.data.data.records.PRODUCT
      this.selectedProducts = {
        code: this.$route.params.key,
        label: response.data.data.records.PRODUCT
      }
      this.compareFields.push(
        { key: String(Object.values(this.selectedProducts)[0]), 
          label: Object.values(this.selectedProducts)[1],
          formatter: (value, key, item) => {
            return value ? value.replace(/(<([^>]+)>)/gi, "") : "";
          },
          sortable: false 
        }
      )
      this.excelFields.push(Object.values(this.selectedProducts)[1])
      this.excelFieldsVal.push(Object.values(this.selectedProducts)[0])
    })
  },
  methods: {
    async getProductDropdown() {
      this.code = [this.$route.params.key]
      return await this.$http
        .get('/compare', {
          params: {
            param: this.code
          },
        })
        .then(({ data }) => {
          this.products = data.productList
          this.compare = data.compareList
          this.$refs.table.refresh();
          this.loading = false
          if(data.productListCount < 2){
            this.showModalNeedAccess()
          }
        })
    },
    showModalNeedAccess() {
      this.$refs['modal-notif'].show()
    },
    clearSelectedProduct() {
      this.loading = true
      this.selectedProducts = null
      this.compare = []
      this.compareFields = []
      this.compareFields.push(
        { key: 'param', label: 'Parameter', sortable: false }
      )
      this.$http
        .get(`/compare`)
        .then(res => {
          this.products = res.data.productList
          this.loading = false
        })
    },
    onChangeProduct(val) {
      this.loading = true
      this.code = this.pluck(val,'code')
      this.products = []
      this.compareFields = []
      this.excelFields = []
      this.excelFieldsVal = []
      this.excelFields.push('Parameter')
      this.excelFieldsVal.push('param')
      this.compareFields.push(
        { key: 'param', label: 'Parameter', sortable: false }
      )
      val.forEach(element => {
        this.compareFields.push(
          { key: String(element.code), 
            label: element.label,
            formatter: (value, key, item) => {
              return value ? value.replace(/(<([^>]+)>)/gi, "") : "";
            },
            sortable: false 
          }
        )
        this.excelFields.push(String(element.label))
        this.excelFieldsVal.push(String(element.code))
      });
      
      this.$http
        .get('/compare', {
          params: {
            param: this.code
          },
        })
        .then(({ data }) => {
          this.products = data.productList
          this.compare = data.compareList
          this.$refs.table.refresh();
          this.loading = false
        })
    },
    pluck(array, key) {
      return array.map(o => o[key]);
    },
    exportToExcel (records, headers, fieldVal, filename, formatJson) {
      import('@/libs/Export2Excel').then(excel => {
          const list = records
          const data = formatJson(fieldVal, list)
          excel.export_json_to_excel({
            header: headers,
            data,
            filename,
            autoWidth: true,
            bookType: 'xlsx'
          })
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        let data = null
        data =  v[j] ? v[j].replace(/(<([^>]+)>)/gi, "") : "";

        return data
      }))
    },
    detail(){
      const routeName = this.$route?.name || ''
      const rootText = this.$route?.meta?.breadcrumb?.[0]?.text || ''
      if (routeName.includes('bundling') || rootText === 'Product Bundling') {
        this.$router.push({name : 'product-bundling-detail', params:{key:this.$route.params.key}})
      } else if(this.$route.meta.breadcrumb[1].text == 'Communication'){
        this.$router.push({name : 'product-communication-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'Datacomm'){
        this.$router.push({name : 'product-datacomm-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'Internet'){
        this.$router.push({name : 'product-internet-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'Wireless'){
        this.$router.push({name : 'product-wireless-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'CONS'){
        this.$router.push({name : 'product-cfu-cons-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'EBIS'){
        this.$router.push({name : 'product-cfu-ebis-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'WIBS'){
        this.$router.push({name : 'product-cfu-wibs-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'Segmentation'){
        this.$router.push({name : 'product-segmentation-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'Targeting'){
        this.$router.push({name : 'product-targeting-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'Cyber Security'){
        this.$router.push({name : 'product-cyber-security-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'Fitur'){
        this.$router.push({name : 'product-fitur-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'Produk'){
        this.$router.push({name : 'product-produk-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'Varian'){
        this.$router.push({name : 'product-varian-detail', params:{key:this.$route.params.key}})
      }else if(this.$route.meta.breadcrumb[1].text == 'DTP'){
        this.$router.push({name : 'product-dtp-detail', params:{key:this.$route.params.key}})
      }
    }
  },
  mounted() {
    Promise.all([this.getProductDropdown()])
  }
}
</script>

<style>
.b-avatar.badge-light-danger {
  background-color: red;
  color: white
}

.title {
  color:black;
}

.no-data > .card-body{
  padding:1rem !important;
}

.no-data > .card-body > .card-title{
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-size: 1.2em;
  color: gray;
}

@media (max-width: 767px) {
  .page-title {
    font-size: 1.4rem;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
